import { useEffect, useState } from "react";
import { BiSolidEdit } from "react-icons/bi";
import { FaHandshake } from "react-icons/fa";
import { IoIosCloseCircle } from "react-icons/io";
import formatValues from "../../../../scripts/formatValues.js";
import styles from "./css/agentMenu.module.css";


export default function AgentMenu({ view, data, openEditor, openCompaniesModal, close }) {

  const [agent, setAgent] = useState({});

  useEffect(() => {
    if (data) {
      setAgent(data);
    }
  }, [data])



  // SCREEN =============================================>

  return view && (
    <div className={styles.openCompanyArea}>

      <div className={styles.openCompanyOverflow} />

      <div className={styles.openCompanyBox}>

        <div className={styles.headerCompanyBox}>
          <div className={styles.headerCompanyBox} style={{ justifyContent: 'flex-start' }}>
            <button className={styles.editCompanyDataButton} onClick={() => openEditor()}>
              <BiSolidEdit size={20} />
            </button>

            <p className={styles.companyName}>{agent.name}</p>
          </div>

          <button className={styles.closeButton} onClick={() => close()}>
            <IoIosCloseCircle size={30} color="#fff" />
          </button>
        </div>



        <div className={styles.informationsArea}>

          <div className={styles.titleArea}>
            <p className={styles.titleInformations} style={{ margin: 0 }}>Dados do comissionado:</p>

            <span
              className={styles.statusInformationArea}
              style={{ backgroundColor: agent.status ? 'var(--color-green)' : 'var(--color-grey)' }}
            >
              {agent.status ? 'Ativo' : 'Inativo'}
            </span>
          </div>

          <p className={styles.textInformations}>
            <b>Nome:</b> {agent.name}
          </p>

          <p className={styles.textInformations}>
            <b>Telefone:</b> {agent.phone ?? 'Sem dados'}
          </p>

          <p className={styles.textInformations}>
            <b>Email:</b> {agent.email ?? 'Sem dados'}
          </p>

          <p className={styles.textInformations}>
            <b>Observações:</b> {agent.notes ?? 'Sem dados'}
          </p>

          <p className={styles.textInformations}>
            <b>Registrado em:</b> {agent.createdAt ? new Date(agent.createdAt).toLocaleString('pt-BR') : '—'}
          </p>


          <div className={styles.titleArea}>
            <p className={styles.titleInformations} style={{ margin: 0 }}>Comissão:</p>
          </div>

          <p className={styles.textInformations}>
            <b>Empresas vinculadas ativas:</b> {agent.activeCompaniesCount ?? 0}
          </p>

          <p className={styles.textInformations}>
            <b>A receber este mês:</b> {agent.status ? formatValues(agent.dueThisMonth ?? 0) : 'Comissionado inativo — não conta no total'}
          </p>


          <div className={styles.actionButtonsArea}>
            <button
              className={styles.actionButtonConfig}
              style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8, color: '#fff' }}
              onClick={() => openCompaniesModal()}
            >
              <FaHandshake size={18} color="#fff" />
              Gerenciar empresas vinculadas
            </button>
          </div>

        </div>
      </div>

    </div>
  );
}
